module.exports = __webpack_public_path__ + "img/rcscolaire.071338cc.png";